import { useEffect } from "react"
import { Navigate, Route, Routes, useLocation } from "react-router-dom"

import Home from "./pages/Home"
import About from "./pages/About"
import Contactus from "./pages/Contactus"
import Section1 from "./pages/Section1"
import Section2 from "./pages/Section2"
import Section3 from "./pages/Section3"
import Section4 from "./pages/Section4"
import Section5 from "./pages/Section5"
import Section6 from "./pages/Section6"
import Section7 from "./pages/Section7"
import VehicleTrackingPage from "./pages/Section8"
import VideoTelematicsPage from "./pages/Section9"
import Section10 from "./pages/Section10"
import TestimonialSlider from "./components/home/Testimonials"

import WhatsAppFloat from "./components/WhatsAppFloat" 

function ScrollToLocation() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      requestAnimationFrame(() => {
        document.querySelector(hash)?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        })
      })
      return
    }

    window.scrollTo({ top: 0, behavior: "auto" })
  }, [pathname, hash])

  return null
}

function App() {
  return (
    <>
      <ScrollToLocation />
      
      <WhatsAppFloat /> 

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/testimonials" element={<TestimonialSlider />} />

        <Route path="/services" element={<Section1 />} />
        <Route path="/section-1" element={<Section1 />} />
        <Route path="/section-2" element={<Section2 />} />
        <Route path="/section-3" element={<Section3 />} />
        <Route path="/section-4" element={<Section4 />} />
        <Route path="/section-5" element={<Section5 />} />
        <Route path="/section-6" element={<Section6 />} />
        <Route path="/section-7" element={<Section7 />} />
        <Route path="/section-8" element={<VideoTelematicsPage />} />
        <Route path="/section-9" element={<VehicleTrackingPage />} />
        <Route path="/section-10" element={<Section10 />} />
        <Route path="/fuel-costs" element={<Section5 />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}

export default App